<template>
	<div class="col-sm-12 col-md-12 col-lg-12 col-xl-6 mb-4">
		<div class="card h-100">
			<div class="card-header ">
				<h5 class="card-title">Recent Notifications</h5>
			</div>
			<div class="card-body pb-0">
				<!--<div class="loader"></div>-->
				<ul class="list-group list-group-flush">
					<li class="list-group-item d-flex justify-content-between align-items-center" v-for="notification in notifications">
						<p class="mb-0 click-cursor">
							<span v-html="notification.message"></span><br>
							<span class="text-secondary" :title="notification.createdAt">{{(notification.createdAt) | fromNow }}</span>
						</p>
						<span class="badge badge-pill" :class="getStatusClass(notification.type)">{{notification.type.toUpperCase()}}</span>
					</li>
				</ul>
			</div>
			<div class="card-footer pt-0">
				<hr class="mt-0">
				<div class="stats">
					<router-link tag="a" :to="{ name: 'notificationsPage' }" class="text-secondary nounderline">
						<i class="fa fa-ticket"></i> View All
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import notificationMixin from "../../../mixins/notificationMixin"

    export default {
        name: "NotificationList",
        mixins: [notificationMixin],
        computed: {
            userToken() {
                return this.$store.getters.getUserToken;
            },
            user() {
                return this.$store.getters.user;
            },
            notifications() {
                return this.$store.getters['notification/getLastFourNotifications'];
            }
        },
    }
</script>
